import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signoutRequest } from 'redux/actions/authActions';
import './Sidebar.scss';

const Sidebar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user?.user);
  const originUser = useSelector(state => state.user);

  const handleSignOut = () => {
    dispatch(signoutRequest(history));
  };

  const onPressGroupOrderDashboard = () => {
    window.open(
      originUser?.adminToken
        ? `${process.env.REACT_APP_GROUP_ORDER_APP_URL}grouporder-dashboard/${user.id}?token=${originUser?.adminToken}`
        : `${process.env.REACT_APP_GROUP_ORDER_APP_URL}grouporder-dashboard/${user.id}`,
      '_blank',
    );
  };

  if (!user || !user.confirmed) {
    return null;
  }

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          <li className="sidebar-item">
            <NavLink
              to="/settings"
              className="sidebar-link"
              activeClassName="active"
            >
              <svg
                className="sidebar-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z" />
              </svg>
              Account Details
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink
              to="/payments"
              className="sidebar-link"
              activeClassName="active"
            >
              <svg
                className="sidebar-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
              </svg>
              Payment Methods
            </NavLink>
          </li>
          {user?.id && (
            <li className="sidebar-item">
              <button
                onClick={onPressGroupOrderDashboard}
                className="sidebar-link "
              >
                <svg
                  className="sidebar-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2s-.89 2-2 2s-2-.89-2-2M4 1v3h14V1H4M4 8.5V19h2.5v-7.5h3V19H12v-7.5h3V19h2.5V8.5H4Z" />
                </svg>
                Corporate Order Dashboard
              </button>
            </li>
          )}
          <li className="sidebar-item">
            <NavLink
              to="/favorites"
              className="sidebar-link"
              activeClassName="active"
            >
              <svg
                className="sidebar-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z" />
              </svg>
              My Favorites & Saved Orders
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink
              to="/reports"
              className="sidebar-link"
              activeClassName="active"
            >
              <svg
                className="sidebar-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
              </svg>
              Reports
            </NavLink>
          </li>
          <li className="sidebar-item">
            <NavLink
              to="/my-orders"
              className="sidebar-link"
              activeClassName="active"
            >
              <svg
                className="sidebar-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z" />
              </svg>
              Orders
            </NavLink>
          </li>
        </ul>

        <div className="socials my-4">
          <button onClick={handleSignOut} className="sign-out">
            <svg
              className="sidebar-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
            </svg>
            Sign Out
          </button>
          <div className="social-icon">
            <a
              href="http://facebook.com/pandaonwheels"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="icon icon-facebook">
                <use xlinkHref="#social--spriteIcon-facebook" />
              </svg>
            </a>
            <a
              href="https://twitter.com/pandaonwheels"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="icon icon-twitter">
                <use xlinkHref="#social--spriteIcon-twitter" />
              </svg>
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
